import * as Yup from 'yup';

// FNP-999: `parameters` is AWSJSON — a string containing JSON. Validate that it
// parses, and that it parses to an OBJECT, before it can be saved.
//
// Why this matters: an unparseable or wrongly-shaped value is not rejected by
// the API (AWSJSON accepts any valid JSON, and the orchestrator reads keys off
// it at runtime). A bad value here surfaces as an orchestrator failure several
// steps later, which is exactly the debugging cost FNP-997 was about.
//
// Empty is allowed and means "no change" — see normalizeParameters.
export const isValidParametersJson = (value?: string): boolean => {
    if (typeof value !== 'string' || value.trim() === '') return true;

    let parsed: unknown;
    try {
        parsed = JSON.parse(value);
    } catch {
        return false;
    }

    // A bare string/number/array would be valid JSON but is never a valid
    // parameters payload — the orchestrator reads named keys off an object.
    return typeof parsed === 'object' && parsed !== null && !Array.isArray(parsed);
};

export const RecordSchema = Yup.object()
                               .shape({
                                          phaseId: Yup.string()
                                                      .required('Required'),
                                          playbookId: Yup.string()
                                                         .required('Required'),
                                          name: Yup.string()
                                                   .required('Required'),
                                          position: Yup.number()
                                                       .typeError('Position must be a number')
                                                       .integer('Position must be an integer')
                                                       .min(0, 'Position must be zero or greater')
                                                       .required('Required'),
                                          parameters: Yup.string()
                                                         .test(
                                                             'is-json-object',
                                                             'Must be a valid JSON object, e.g. {"stagesToValidate":["test"]}',
                                                             isValidParametersJson,
                                                         ),
                                      });
